import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { DotsSixVertical as DragIcon } from "@phosphor-icons/react/DotsSixVertical";
import { PencilSimple as EditIcon } from "@phosphor-icons/react/PencilSimple";
import { Trash as DeleteIcon } from "@phosphor-icons/react/Trash";
import { ReactNode, useEffect, useState } from "react";
import {
	DragDropContext,
	Draggable,
	Droppable,
	DropResult,
} from "react-beautiful-dnd";

interface Navigator {
	active: boolean;
	content: string;
	index: number;
	key: string;
	label: string;
	width: number;
	id: string;
}

interface Props {
	navigators: Navigator[];
	onChange: (navigators: Navigator[]) => void;
}

export const SortableMenu = (props: Props) => {
	const { navigators, onChange } = props;
	const [items, setItems] = useState<Navigator[]>([]);

	useEffect(() => {
		setItems(navigators);
	}, [navigators]);

	const onDragEnd = (result: DropResult) => {
		const { destination, source } = result;

		if (!destination) return;

		const reorderedItems = Array.from(items);
		const [removed] = reorderedItems.splice(source.index, 1);
		if (removed) reorderedItems.splice(destination.index, 0, removed);

		setItems(reorderedItems);
		onChange(reorderedItems);
	};

	const handleRemove = (id: string) => {
		const filteredItems = items.filter((item) => item.id !== id);
		setItems(filteredItems);
		onChange(filteredItems);
	};

	return (
		<>
			{/* @ts-ignore */}
			<DragDropContext onDragEnd={onDragEnd}>
				{/* @ts-ignore */}
				<Droppable droppableId="droppable-column">
					{(provided) => (
						<div
							{...provided.droppableProps}
							ref={provided.innerRef}>
							{items.map((item, index) => (
								<>
									{/* @ts-ignore */}
									<Draggable
										key={item.id}
										draggableId={item.id}
										index={index}>
										{(provided) => (
											<Stack
												spacing={2}
												direction="row"
												ref={provided.innerRef}
												{...provided.draggableProps}
												{...provided.dragHandleProps}
												sx={{
													alignItems: "center",
													flexWrap: "wrap",
													justifyContent: "space-between",
													px: 3,
													py: 5,
												}}
												style={{
													userSelect: "none",
													padding: "16px",
													margin: "0 0 8px 0",
													backgroundColor: "var(--mui-palette-grey-100)",
													borderRadius: "8px",
													...provided.draggableProps.style,
												}}>
												<Stack
													direction="row"
													spacing={2}
													sx={{ alignItems: "center" }}>
													<IconButton>
														<DragIcon size={24} />
													</IconButton>
													<Typography variant="subtitle1">
														{item.label}
													</Typography>
												</Stack>
												<Stack
													direction="row"
													spacing={2}
													sx={{ alignItems: "center" }}>
													<IconButton>
														<EditIcon size={24} />
													</IconButton>
													<IconButton
														onClick={() => {
															handleRemove(item.id);
														}}>
														<DeleteIcon size={24} />
													</IconButton>
												</Stack>
											</Stack>
										)}
									</Draggable>
								</>
							))}
							{provided.placeholder as ReactNode}
						</div>
					)}
				</Droppable>
			</DragDropContext>
		</>
	);
};
